import Api from '@/api'

export default {
  fetchFormQuestionnaire(formId) {
    return Api.get(`/eadvisory/forms/${formId}`)
  },

  fetchAnswersRisk(formId, payload, personId) {
    return Api.post(`/eadvisory/forms/${formId}/results`, { personId, ...payload })
  }
}
